import { ReactNode } from 'react';
import cn from 'classnames';
import { FlexWrapper } from '../../FlexWrapper';
import { FontIcon } from '../../FontIcon';
import toastStyles from '../styles.module.sass';
import styles from './expiration-banner.module.sass';

export const ExpirationBanner = ({ children }: { children: ReactNode | string }) => {
    return (
        <FlexWrapper flexGrow className={cn(toastStyles.toast, styles.banner)}>
            <div className={toastStyles.icon}>
                <FontIcon name="info" size="large" md="large" />
            </div>
            <FlexWrapper flexGrow>{children}</FlexWrapper>
        </FlexWrapper>
    );
};
